<div class="checkbox">
  <input type="checkbox" [formControl]="checkBoxControl" [id]="filterItem.code"/>
  <label [for]="filterItem.code">{{ filterItem.name | translate }}</label>
</div>
